import { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { KIOSK_PAGE_KEYS } from '../utils/kioskLandingDefaults';
import {
  defaultTermsAndConditions,
  normalizeTermsAndConditions,
} from '../utils/kioskLandingDefaults';
import { useKioskLandingConfig } from '../hooks/useKioskLandingConfig';
import { sanitizeHtml } from '../../../shared/utils/sanitizeHtml';
import './PassportScanConsentBar.css';
import '../pages/FaceIdentityLandingPage.css';

/**
 * Passport scan footer: outlet Theme & page setup background + landing-style consent card.
 */
export default function PassportScanConsentBar({ checked, onCheckedChange }) {
  const { config } = useKioskLandingConfig(KIOSK_PAGE_KEYS.FACE_IDENTITY);
  const [termsOpen, setTermsOpen] = useState(false);

  const consent = config?.consent || {};
  const checkboxLabel =
    consent.checkboxLabel || 'I agree to the face scan consent and terms & conditions';
  const consentText =
    consent.text ||
    'By proceeding, you consent to collection and processing of your face data for identity check-in and service personalization under applicable Indian law.';

  const terms = useMemo(
    () => normalizeTermsAndConditions(config?.termsAndConditions || defaultTermsAndConditions()),
    [config?.termsAndConditions],
  );
  const termsHtml = useMemo(() => sanitizeHtml(terms.body || ''), [terms.body]);
  const termsLinkLabel = terms.title || 'Terms and Conditions';

  const termsModal =
    termsOpen && typeof document !== 'undefined'
      ? createPortal(
          <div className="fi-passport-terms-modal" role="dialog" aria-modal="true" aria-labelledby="fi-passport-terms-title">
            <button
              type="button"
              className="fi-passport-terms-modal__backdrop"
              aria-label="Close terms"
              onClick={() => setTermsOpen(false)}
            />
            <div className="fi-passport-terms-modal__panel">
              <header className="fi-lux__terms-modal-head">
                <h2 id="fi-passport-terms-title">{termsLinkLabel}</h2>
                <button type="button" onClick={() => setTermsOpen(false)} aria-label="Close">
                  ×
                </button>
              </header>
              <div
                className="fi-lux__terms-modal-body ql-editor"
                dangerouslySetInnerHTML={{ __html: termsHtml }}
              />
            </div>
          </div>,
          document.body,
        )
      : null;

  return (
    <footer className="fi-passport-consent" aria-label="Consent and terms">
      <div className="fi-passport-consent__inner fi-lux__consent-wrap">
        <label className="fi-lux__consent-label fi-passport-consent__label">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => onCheckedChange(e.target.checked)}
          />
          <span>{checkboxLabel}</span>
        </label>
        {consentText ? <p className="fi-lux__consent-text fi-passport-consent__text">{consentText}</p> : null}
        <button type="button" className="fi-lux__terms-link fi-passport-consent__terms-link" onClick={() => setTermsOpen(true)}>
          {termsLinkLabel}
        </button>
      </div>
      {termsModal}
    </footer>
  );
}
